<template>
  <div @click="childBtnClick()" :class="['child-btn', background && 'show-back']">
    {{ twoMenu.title }}
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: {
    twoMenu: Object,
    //背景图显示
    background: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    };
  },
  computed:{
  },
  mounted(){
  },
  methods:{
    ...mapMutations(['setCollapsed', 'setActiveTwo', 'setFloatVisibel']),
    /** 点击子按钮 跳转路由 */
    childBtnClick() {
      //跳转路由
      this.$router.push({
        name: this.twoMenu.name
      })
      //选中二级菜单
      this.setActiveTwo(this.twoMenu)
      //折叠菜单
      this.setCollapsed(true)
      //隐藏浮动菜单
      this.setFloatVisibel()
    }
  }
};
</script>
<style lang="less" scoped>
  .child-btn{
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
    width: 250px;
    height: 80px;
    border-radius: 10px;
    color: #fff;
    font-size: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 2px;
    margin-right: 30px;
    margin-bottom: 30px;
    &.show-back{
      background-image: url('../../static/img/child-btn.png');
    }
  }
</style>
